// extracted by mini-css-extract-plugin
export default {"container":"cell_container__JRJXg"};